import { useContext, useEffect, useState } from "react";
import { AppContext } from "../context";
import { getQuickLinksConsole } from "../services/console/quicklinks";

type UseType = "SELECT_TENANT_DASHBOARD" | "SELECT_APP_DASHBOARD" | "APP_DASHBOARD" | "TOOLS_DASHBOARD";

export const useQuickLinksConsole = (type: UseType) => {
  const { 
    toast, 
    appState: { tenantId, selectedTenantId, selectedApp } 
  } = useContext(AppContext);
  const [data, setData] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);

  const reloadFn = () => {
    setData(null);
    setReload((prev) => prev + 1);
  };

  useEffect(() => {
    if (type) {
      const roleId = (type === "APP_DASHBOARD" || type === "TOOLS_DASHBOARD") && selectedApp?.roleid;
      (async function () {
        await Promise.resolve(getQuickLinksConsole(type, type === "SELECT_TENANT_DASHBOARD" ? tenantId : selectedTenantId, roleId))
          .then((response) => {
            setData(response?.data);
          })
          .catch((error) => {
            setData([]);
            console.log(error);
          });
      })();
    }
  }, [toast, reload, type, tenantId, selectedTenantId]);

  return {
    data,
    reloadFn,
  };
};
